<div
  class="menu-overflow-container"
  [attr.data-size]="size"
  [attr.data-variant]="variant"
  [attr.data-direction]="direction"
  [attr.data-align]="align"
  [attr.data-disabled]="disabled"
  [attr.data-loading]="loading"
  [attr.data-open]="isOpen"
>
  <button
    #trigger
    type="button"
    class="menu-overflow-trigger"
    [disabled]="disabled || loading"
    [attr.role]="'button'"
    [attr.aria-label]="displayAriaLabel"
    [attr.aria-expanded]="isOpen"
    [attr.aria-haspopup]="'menu'"
    [attr.tabindex]="disabled ? -1 : 0"
    (click)="onOverflowToggle()"
    (keydown)="onKeyDown($event)"
  >
    <!-- Loading Spinner -->
    <div *ngIf="loading" class="overflow-loading">
      <umss-icon
        name="phosphorCircleNotch"
        size="16px"
        class="spinner-icon"
      ></umss-icon>
    </div>

    <!-- Icon -->
    <span *ngIf="!loading" class="overflow-icon">
      <umss-icon [name]="icon" size="20px"></umss-icon>
    </span>
  </button>

  <!-- Overflow Menu Content -->
  <div
    *ngIf="isOpen && !loading"
    [@menuOverflowAnimation]="menuAnimationParams"
    class="overflow-menu"
    [style.top]="menuPosition.top"
    [style.left]="menuPosition.left"
  >
    <ng-content></ng-content>
  </div>

  <!-- Click Outside Handler -->
  <div
    *ngIf="isOpen"
    class="overflow-backdrop"
    tabindex="0"
    role="button"
    [attr.aria-label]="'Close menu'"
    (click)="onClickOutside()"
    (keydown)="onClickOutside()"
  ></div>
</div>
